var _style, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _rect2, _path9, _polygon, _rect3, _path0, _path1, _path10, _path11, _path12, _rect4, _path13, _path14, _path15, _path16, _polygon2, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerlindeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 527.4 108.7",
    style: {
      enableBackground: "new 0 0 527.4 108.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.1,75.4l23.4-73.6h14.6l-24.1,73.6H109.1z M105.6,68L83.9,1.8h14.8c0,0,10.3,32.8,13.9,44.2L105.6,68z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.7,45.1h-24.2V32h24.2V45.1z M160.9,52.2c0,6.8,2.7,9.4,9.3,9.4h25.9v13.8h-26c-15.2,0-23.2-9.3-23.2-23.4 V25.2c0-14.1,8.1-23.4,23.2-23.4h26v13.8h-25.9c-6.7,0-9.3,2.5-9.3,9.3V52.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.9,75.4h-14V56.6c0-6.5-3-9.4-9.5-9.4h-8.1v-13h8.9c1.8,0,10.9-0.5,10.9-9.6c0-2.4,0-9.6-11.2-9.6h-14.1 v60.5h-14.1V1.8h28.2c15.4,0,25.2,8.2,25.2,21.9c0,8.4-3.9,13.8-10.3,16.8c5.2,3,8.1,8,8.1,15.8V75.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261,52.2V1.8h14V52c0,6.8,2.5,9.6,9.2,9.6h22.2v13.8h-22.3C269,75.4,261,66.3,261,52.2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 1.8,
    className: "st0",
    width: 14,
    height: 73.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.2,7.5c4.8,4.8,7.4,11.6,7.4,19.1v48.8h-14V26.3c0-7.8-4.8-12.6-12.7-12.6c-7.8,0-12.6,4.8-12.6,12.6v49.1 h-14V26.6c0-7.5,2.7-14.3,7.4-19.1c4.9-4.9,11.7-7.5,19.2-7.5C368.6,0,375.4,2.7,380.2,7.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.9,62.3c16.6,0,19.2-15,19.2-23.9c0-10.8-3.4-23.6-19.2-23.6h-12.2v60.5h-14V1.8h26.2 c20.5,0,33.2,14.1,33.2,36.8c0,22.5-13,36.8-33.2,36.8h-6.6v-13H422.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.7,45.1h-24.2V32h24.2V45.1z M474.9,52.2c0,6.8,2.7,9.4,9.3,9.4h25.9v13.8h-26c-15.2,0-23.2-9.3-23.2-23.4 V25.2c0-14.1,8.1-23.4,23.2-23.4h26v13.8h-25.9c-6.7,0-9.3,2.5-9.3,9.3V52.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.3,104v2.1h-5.2c-3.3,0-5.4-2-5.4-5.4V88.2h2.2v12.5c0,2.1,1.1,3.3,3.2,3.3H272.3z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 275.7,
    y: 88.2,
    className: "st0",
    width: 2.2,
    height: 17.9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.7,96.1h7.3v2h-7.3v7.9h-2.2V93.6c0-3.4,2.1-5.4,5.4-5.4h5.3v2.1h-5.3c-2.1,0-3.2,1.2-3.2,3.3V96.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "304,90.3 304,106.1 301.8,106.1 301.8,90.3 296.1,90.3 296.1,88.2 309.6,88.2 309.6,90.3 "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 312.7,
    y: 88.2,
    className: "st0",
    width: 2.2,
    height: 17.9
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.1,94v12.1H330V94c0-2.4-1.9-4.2-4.1-4.2c-2.3,0-4.1,1.8-4.1,4.2v12.1h-2.2V94c0-3.6,2.8-6.3,6.3-6.3 C329.4,87.8,332.1,90.5,332.1,94"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.2,96.4v0.9c0,5.5-3.5,9.1-8.7,9.1c-4.9,0-8.9-4.2-8.9-9.3c0-5.1,4-9.3,8.9-9.3c3.6,0,6.9,2,8.3,6h-2.3 c-1.1-2.4-3.3-3.8-6-3.8c-3.7,0-6.7,3.3-6.7,7.2c0,3.9,3,7.2,6.7,7.2c3.7,0,6.1-2.5,6.4-5.8h-6.3v-2.1H353.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.5,96.1h8.4v2h-8.4v2.6c0,2.1,1.1,3.3,3.2,3.3h6.3v2.1h-6.3c-3.3,0-5.4-2-5.4-5.4v-7.2 c0-3.4,2.1-5.4,5.4-5.4h6.3v2.1h-6.3c-2.1,0-3.2,1.2-3.2,3.3V96.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.5,89.8c-3.7,0-6.7,3.2-6.7,7.2c0,3.7,2.4,6.6,5.6,7.1v-2.1h2.2v2.1c3.2-0.6,5.6-3.5,5.6-7.1 C394.2,92.9,391.3,89.8,387.5,89.8 M388.6,108.7h-2.2v-2.3c-4.4-0.6-7.8-4.5-7.8-9.3c0-5.2,4-9.3,8.9-9.3c5,0,8.9,4,8.9,9.3 c0,4.8-3.4,8.7-7.8,9.3V108.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.6,104.3c3,0,4.7-2,4.7-4.6V88.2h2.2v11.5c0,4-2.8,6.7-6.9,6.7c-4.1,0-6.9-2.8-6.9-6.7V88.2h2.2v11.5 C401.9,102.3,403.6,104.3,406.6,104.3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 417.9,
    y: 88.2,
    className: "st0",
    width: 2.2,
    height: 17.9
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431,89.8c-2.3,0-4.1,1.7-4.1,4.2v3.2h4.2c2.6,0,4-1.5,4-3.7C435,91.5,433.3,89.8,431,89.8 M431.1,99.4h-4.2 v6.7h-2.2v-12c0-3.7,2.6-6.3,6.3-6.3c3.4,0,6.2,2.6,6.2,5.8C437.2,97.1,434.8,99.4,431.1,99.4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.4,106.1h-2.2V93.8c0-2.1-1.7-3.9-3.8-3.9c-2.2,0-3.8,1.8-3.8,3.9v12.3h-2.2V93.8c0-2.1-1.6-3.9-3.8-3.9 c-2.2,0-3.8,1.8-3.8,3.9v12.3h-2.2V93.8c0-3.3,2.6-6,6-6c2.2,0,3.9,1.1,4.9,2.7c1-1.6,2.8-2.7,5-2.7c3.4,0,6,2.7,6,6V106.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.7,96.1h8.4v2h-8.4v2.6c0,2.1,1.1,3.3,3.2,3.3h6.3v2.1h-6.3c-3.3,0-5.4-2-5.4-5.4v-7.2 c0-3.4,2.1-5.4,5.4-5.4h6.3v2.1h-6.3c-2.1,0-3.2,1.2-3.2,3.3V96.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M494.6,94v12.1h-2.2V94c0-2.4-1.9-4.2-4.1-4.2c-2.3,0-4.1,1.8-4.1,4.2v12.1H482V94c0-3.6,2.8-6.3,6.3-6.3 C491.8,87.8,494.6,90.5,494.6,94"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "496.8,88.2 496.8,90.3 502.4,90.3 502.4,106.1 504.6,106.1 504.6,90.3 510.2,90.3 510.2,88.2 "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.7,64.5c0,6-4.9,10.9-10.9,10.9h-51C4.9,75.4,0,70.5,0,64.5V12.8c0-6,4.9-10.8,10.8-10.8h51 c6,0,10.9,4.9,10.9,10.8V64.5z M22,4.1l7.3,25.7h27.6l7.3-25.7H42.1l-5.2,18.1L32.1,4.1H22z M15.6,29.9h8.6L16.9,4.1H8.3L15.6,29.9z  M55,44.6c-0.1,0-0.1,0.1-0.2,0.1l-5.7,7v0c0,6.4-5.2,11.7-11.7,11.7c-0.7,0-1.4-0.1-2.1-0.2c-8.9-1.9-8.3-11.9-8.3-11.9 c0.1-2.7,1.5-4.8,3.1-6.4l-0.1,0c0,0,0.2-0.1,0.5-0.3c1-0.9,2-1.6,2.9-2.1c3.4-2.6,12-6.6,14.7-10.2h-7.5l0,0l-13.6,0 c-1.4,4.1-5.4,2-10.8,10.2c-8.3,12.6,0.4,27.1,10.7,30c0,0,7.6,2.8,13.7,0.4c8.5-3.3,13.8-10.7,14.2-18.5c0.2-3.4,1.2-6.5,1.7-8.6 C57,44.9,55.8,44,55,44.6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519.6,5.7h1.6c0.8,0,1.7,0.2,1.7,1.2c0,1.2-1,1.2-2,1.2h-1.2V5.7z M518.4,12.3h1.2V9h1.2l2.1,3.2h1.3L522,8.9 c1.1-0.1,2-0.7,2-2.1c0-1.5-0.8-2.2-2.6-2.2h-2.9V12.3z M515.6,8.5c0-3.1,2.3-5.5,5.3-5.5c3,0,5.3,2.4,5.3,5.5 c0,3.2-2.3,5.5-5.3,5.5C517.9,14,515.6,11.6,515.6,8.5 M514.4,8.5c0,3.7,3,6.5,6.5,6.5c3.5,0,6.5-2.8,6.5-6.5c0-3.6-3-6.4-6.5-6.4 C517.4,2.1,514.4,4.8,514.4,8.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerlindeWhite);
export default __webpack_public_path__ + "static/media/verlinde-white.fa27f7a2ad283c7b1dda365d20281c73.svg";
export { ForwardRef as ReactComponent };